module.exports = __webpack_public_path__ + "static/media/professional-teaching-ad5.ed878df7.png";